import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const labs = [
  {
    title: 'VergeOS\'a Başlarken',
    desc: 'VergeIO\'dan interaktif, kendi hızınızda ilerleyebileceğiniz uygulamalı bir lab olan <strong>VergeOS\'a Başlarken</strong> ile güçlü veri merkezi işletim sisteminin temellerini öğrenmenin başına sizi koyun. VergeOS\'ta yeni olsanız da birleşik sanallaştırma, ağ ve depolama özelliklerini keşfediyor olsanız da bu rehberli lab, oturum açma, arayüzde gezinme, Windows ve Linux VM\'leri dağıtma, anlık görüntü koruması uygulama ve etiketlerle kaynakları düzenleme adımlarında sizi adım adım yönlendirir.',
    img: 'https://www.verge.io/wp-content/uploads/2025/12/Hands-on-Lab-Getting-Started-with-VergeOS-50pct.webp',
    imgLeft: false,
    highlight: null,
  },
  {
    title: 'Veri Koruma ve Kurtarma Lab\'ı',
    desc: 'VergeOS\'un güçlü <strong>ioClone</strong> destekli anlık görüntü teknolojisiyle verilerinizi her zamankinden daha iyi koruyun. <strong>Veri Koruma ve Kurtarma Lab\'ında</strong>, sanal makineler oluşturacak, hem zamanlanmış hem de manuel anlık görüntüler alacak ve silme işleminden sonra tek tek dosyaları kurtaracaksınız. Bu lab, VergeOS\'un en sıkı kurtarma noktası ve kurtarma süresi hedeflerini karşılamanızı sağlayacak şekilde veri koruma ve felaket kurtarma stratejilerinizi nasıl geliştirebileceğini göstermek için tasarlanmıştır.',
    img: 'https://www.verge.io/wp-content/uploads/2024/05/ioClone-New-May-21-2024b.webp',
    imgLeft: true,
    highlight: 'Veri koruma stratejinizi güçlendirmeye hazır mısınız?',
  },
  {
    title: 'Sanal Veri Merkezleri Lab\'ı',
    desc: 'Sanal Veri Merkezleri (VDC) Lab\'ında VergeOS\'un çok kiracılı <strong>VDC</strong> mimarisinin gücünü keşfedeceksiniz. Kendi sanal veri merkezinizi oluşturun, birden fazla VM dağıtın ve gelişmiş iş yükü dayanıklılığı için kiracılar ve alt kiracılar arasında iş yüklerini izole edin. Bu lab ayrıca yamalar ve diğer kritik operasyonları test etmek için sanal bir lab oluşturma konusunda da size rehberlik edecektir.',
    img: 'https://www.verge.io/wp-content/uploads/2024/01/Virtual-Data-Centers-scaled.webp',
    imgLeft: false,
    highlight: 'Dayanıklı sanal veri merkezleri oluşturmaya hazır mısınız?',
  },
];

const testDriveJsonLd = { '@context': 'https://schema.org', '@type': 'WebPage', name: 'VergeOS Test Drive', url: `${SITE_URL}/test-drive`, description: "VergeOS'u uygulamalı lab ortamında ücretsiz deneyin. Satış araması gerektirmez." };

export default function TestDrivePage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <SEOHead title="Test Drive | VergeOS'u Ücretsiz Deneyin" description="VergeOS'u uygulamalı lab ortamında ücretsiz deneyin. Satış araması gerektirmez, gerçek ortamda deneyim kazanın." keywords="VergeOS test drive, ücretsiz deneme, uygulamalı lab, sanallaştırma testi, hands-on lab" canonicalPath="/test-drive" jsonLd={testDriveJsonLd} />
      <Navbar />

      {/* Hero */}
      <section
        className="relative py-20 bg-cover bg-center"
        style={{ backgroundImage: "url('https://www.verge.io/wp-content/uploads/bb-plugin/cache/vergeio-background-hero-landscape.jpeg')" }}
      >
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center px-6">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">Nihai Test Sürüşü</h1>
          <h2 className="text-xl text-white/90 font-medium">
            Görmeden inanmak olmaz — Donanım Gerektirmez
          </h2>
        </div>
      </section>

      {/* Intro */}
      <section className="py-16 bg-[#f7f8fa]">
        <div className="max-w-[760px] mx-auto px-6">
          <h3 className="text-2xl font-bold text-[#1a1a2e] mb-4">Kontrolü Siz Alın</h3>
          <p className="text-gray-600 mb-4 leading-relaxed text-sm">
            BT altyapısının geleceğine dalmaya hazır mısınız? VergeIO'nun uygulamalı labları, BT profesyonellerine yenilikçi VergeOS platformumuzu keşfetmek için benzersiz, kendi hızında ilerleme fırsatı sunar. Bu lablar; Diğer alternatiflerden geçiş, verileri koruma ve dayanıklı sanal veri merkezleri oluşturma konusunda pratik deneyim kazanmanıza yardımcı olmak için tasarlanmıştır — donanıma gerek yok.
          </p>
          <p className="text-gray-600 mb-8 leading-relaxed text-sm">
            Her lab 7/24 kullanılabilir ve 15 ila 20 dakikada tamamlanabilir. VergeOS'ta yeni olsanız da yetenekleri daha derinlemesine anlamak istiyor olsanız da uygulamalı lablarımız başarılı olmak için ihtiyaç duyduğunuz bilgiyi size sağlayacaktır.
          </p>
          <div className="grid grid-cols-3 gap-4">
            {[
              { icon: 'ri-time-line', val: '15-20 dk', label: 'Lab Süresi' },
              { icon: 'ri-24-hours-line', val: '7/24', label: 'Erişim' },
              { icon: 'ri-server-line', val: '0', label: 'Donanım Gereksinimi' },
            ].map((s, i) => (
              <div key={i} className="bg-white rounded-xl p-4 text-center border border-gray-100">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                  <i className={`${s.icon} text-[#e8600a] text-xl`}></i>
                </div>
                <div className="font-bold text-[#1a1a2e] text-lg">{s.val}</div>
                <div className="text-xs text-gray-400 mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lab Descriptions */}
      <section className="py-16 bg-white">
        <div className="max-w-[1100px] mx-auto px-6 space-y-16">
          {labs.map((lab, i) => (
            <div key={i} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${lab.imgLeft ? 'lg:flex-row-reverse' : ''}`}>
              {lab.imgLeft ? (
                <>
                  <div className="w-full h-56 rounded-xl overflow-hidden">
                    <img src={lab.img} alt={lab.title} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#1a1a2e] mb-4">{lab.title}</h3>
                    <p
                      className="text-gray-600 text-sm leading-relaxed mb-4"
                      dangerouslySetInnerHTML={{ __html: lab.desc }}
                    />
                    {lab.highlight && (
                      <p className="font-semibold text-[#1a1a2e] text-sm">{lab.highlight}</p>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <h3 className="text-xl font-bold text-[#1a1a2e] mb-4">{lab.title}</h3>
                    <p
                      className="text-gray-600 text-sm leading-relaxed mb-4"
                      dangerouslySetInnerHTML={{ __html: lab.desc }}
                    />
                    {lab.highlight && (
                      <p className="font-semibold text-[#1a1a2e] text-sm">{lab.highlight}</p>
                    )}
                  </div>
                  <div className="w-full h-56 rounded-xl overflow-hidden">
                    <img src={lab.img} alt={lab.title} className="w-full h-full object-cover object-top" />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </section>

      <FooterSection />
    </div>
  );
}